const pageData = () => {
    return {
        PG_NO: 1,
        PG_PER_CNT: 30,
        NEXT_YN: "Y",
    }
}

const taskData = () => {
    return {
        USER_ID: _USER_ID,
        USE_INTT_ID: _USE_INTT_ID,
        packetOption: 2,
        PG_NO: 1,
        PG_PER_CNT: 100,
        PG_OFFSET: 0,
        NEXT_YN: "N",
        FIL_STTS: "0,1,4",
        FIL_PRIORITY: "0,1,2,3,4",
        FIL_START_DT_GUBUN: "0",
        STTS_VIEW_YN: "Y",
        PRIORITY_VIEW_YN: "Y",
        END_DT_VIEW_YN: "Y",
        SUBTASK_BUNDLE_YN: "N",
        SECTION_BUNDLE_YN: "N",
        GANTT_YN: "N",
    }
}


const WIDGET = {
    REQUEST_TASK: {
        SRNO: '1',
        KEY: 'requestWork',
        SETTING: {
            delBtn: true,
            sizeBtn: false,
            filterBtn: 'work',
            filter: 'end_dt_filter',
            tabBtn: 'work',
            scroll: true
        }
    }, //요청한 업무
    MY_TASK: {
        SRNO: '3',
        KEY: 'myWork',
        SETTING: {
            delBtn: true,
            sizeBtn: false,
            filterBtn: 'work',
            filter: 'end_dt_filter',
            tabBtn: 'work',
            scroll: true
        }
    }, //내 업무
    MY_SCHEDULE: {
        SRNO: '4',
        KEY: 'calendar',
        SETTING: {type: 'calendar', delBtn: true, todayBtn: true, sizeBtn: false, scroll: true}
    }, //내 일정, 달력
    BOOKMARK: {
        SRNO: '5',
        KEY: 'bookmark',
        SETTING: {delBtn: true, directBtn: true, sizeBtn: true, scroll: true},
        API : {
            API_KEY: 'postList',
            RECORD: 'POST_RECORD',
        },
        INDEX_KEY_SRNO: 'COLABO_COMMT_SRNO'
    }, //북마크
    MENTION: {
        SRNO: '6',
        KEY: 'mention',
        SETTING: {directBtn: true, delBtn: true, sizeBtn: true, scroll: true},
        API : {
            API_KEY: 'postList',
            RECORD: 'POST_RECORD',
        },
        INDEX_KEY_SRNO: 'COLABO_COMMT_SRNO'
    }, //나를 언급
    PROJECT: {
        SRNO: '7',
        KEY: 'projectContent',
        SETTING: {project_binding: true, directBtn: true, delBtn: true, sizeBtn: true, scroll: true},
        INDEX_KEY_SRNO: 'COLABO_SRNO',
        API: {
            RECORD: 'POST_RECORD',
            API_KEY: 'postList',
        }
    }, //프로젝트 게시물
    REPORT: {
        SRNO: '8',
        KEY: 'projectSummary',
        SETTING: {
            delBtn: true,
            sizeBtn: false,
            directBtn: true,
            project_binding: true,
            filterBtn: true,
            filter: 'report_filter',
        },
        API: {
            RECORD: 'POST_RECORD',
            API_KEY: 'getTaskReport',
        },
        INDEX_KEY_SRNO: 'COLABO_COMMT_SRNO'
    }, //업무 리포트
    UNREAD: {
        SRNO: '10',
        KEY: 'unread',
        SETTING: {scroll: true, sizeBtn: true, allReadBtn: true, delBtn: true},
        API : {
            API_KEY: 'getAlarmList',
            RECORD: 'ALARM_REC',
        },
        INDEX_KEY_SRNO: 'ALAM_SRNO'
    }, //미확인 알림
    CHAT: {
        SRNO: '11',
        KEY: 'chat',
        SETTING: {
            delBtn: true, sizeBtn: true, scroll: true, type: 'chat',
            verticalList: true
        },
        API : {
            API_KEY: 'chatList',
            RECORD: 'LIST_REC',
        },
        INDEX_KEY_SRNO: 'ROOM_SRNO'
    }, //채팅
    FILE: {
        SRNO: '13',
        KEY: 'file',
        SETTING: {
            project_binding: true, directBtn: true, sizeBtn: true, scroll: true,
            delBtn: true
        },
        API : {
            API_KEY: 'getFileData',
            RECORD: 'ATCH_REC',
        },
        INDEX_KEY_SRNO: 'ATCH_SRNO'
    }, //파일함
    MEMO: {
        SRNO: '37',
        KEY: 'memo',
        SETTING: {delBtn: true, sizeBtn: true, type: 'memo', scroll: true}
    }, //메모
    MY_PROJECT: {
        SRNO: '40',
        KEY: 'myProject',
        SETTING: {
            delBtn: true,
            sizeBtn: true,
            filterBtn: 'true',
            filter: 'my_prj_filter',
            type: 'my-prj',
            scroll: true,
            verticalList: true
        },
        API: {
            API_KEY: 'getProjectList',
            RECORD: 'PROJECT_RECORD',
        },
        INDEX_KEY_SRNO: 'COLABO_SRNO'
    }, //프로젝트 리스트
    MEMBER: {
        SRNO: '41',
        KEY: 'member',
        SETTING: {
            delBtn: true,
            sizeBtn: true,
            filterBtn: 'true',
            filter: 'member_filter',
            type: 'my-member',
            scroll: true,
            verticalList: true
        },
        API : {
            API_KEY: ['getCompanyUser', 'getWorkerRecommend'],
            RECORD: ['USER_REC', 'USER_RECORD'],
        },
        INDEX_KEY_SRNO: 'USER_ID'
    }, //구성원 리스트
    FREQUENT_MEMBER: {
        SRNO: '43',
        KEY: 'frequentMember',
        SETTING: {
            delBtn: true,
            sizeBtn: false,
        },
        API : {
            API_KEY: 'getWorkerRecommend',
            RECORD: 'USER_RECORD',
        },
        INDEX_KEY_SRNO: 'USER_ID'
    }, //TOP5 자주협업 추천 리스트
    WEEKLY_MY_TASK: {
        SRNO: '44',
        KEY: 'weeklyMyTask',
        SETTING: {
            delBtn: true,
            sizeBtn: false,
            filterBtn: 'true',
            filter: 'month_filter',
        },
        API : {
            API_KEY: 'insightWidget',
            RECORD: 'USER_RECORD',
        },
        INDEX_KEY_SRNO: 'USER_ID'
    }, //주차별 업무 건수
}

const getWidgetName = (WIDGET_SRNO) => {
    switch (WIDGET_SRNO) {
        case WIDGET.REQUEST_TASK.SRNO:
            return i18next.t(main.task.requested);

        case WIDGET.MY_TASK.SRNO:
            return i18next.t(main.task.assigned);

        case WIDGET.MY_SCHEDULE.SRNO:
            return i18next.t(dictionary.schedule);

        case WIDGET.BOOKMARK.SRNO:
            return i18next.t(dictionary.bookMarks);

        case WIDGET.MENTION.SRNO:
            return i18next.t(dictionary.mention);

        case WIDGET.PROJECT.SRNO:
            return i18next.t(dictionary.project);

        case WIDGET.REPORT.SRNO:
            return i18next.t(main.widget.projectTaskStatistic);

        case WIDGET.UNREAD.SRNO:
            return i18next.t(common.unreadNoti);

        case WIDGET.CHAT.SRNO:
            return i18next.t(common.chatRoom);

        case WIDGET.FILE.SRNO:
            return i18next.t(common.filesStorage);

        case WIDGET.MEMO.SRNO:
            return i18next.t(dictionary.notepad);

        case WIDGET.MY_PROJECT.SRNO:
            return i18next.t(common.my, {val: i18next.t(dictionary.project)});

        case WIDGET.MEMBER.SRNO:
            return i18next.t(dictionary.member);

        case WIDGET.FREQUENT_MEMBER.SRNO:
            return i18next.t(main.widget.top5Member);

        case WIDGET.WEEKLY_MY_TASK.SRNO:
            return i18next.t(main.widget.workByWeek);

    }
}


const WIDGET_SRNO = {
    0: "background", //배경 이미지
    1: "request-work", //요청한 업무
    2: "banner", //배너
    3: "my-work", //내 업무
    4: "schedule", //내 일정, 달력
    5: "bookmark", //북마크
    6: "mention", //나를 언급@
    7: "project-content", //프로젝트
    8: "project-summary", //프로젝트 리포트
    9: "project-list", //즐겨찾는 프로젝트
    10: "alarm", //미확인 알림
    11: "chat", //채팅
    12: "profile-change", //프로필 변경 기능
    13: "file-list", //파일함
    14: "star", //즐겨찾기
    15: "major-notice", //주요알림정보
    16: "prj-mng", //사업 추진관리
    17: "my-fnncl-acntn", //나의 재무회계
    18: "mmbrs-feest", //회원 및 수수료 현황
    19: "press-release", //보도자료
    20: "todo", //ToDo
    21: "news-scrp", //신문스크랩
    22: "union-news", //혁신노조소식
    23: "anti-corr-board", //청렴광장
    24: "intrn-mail", //내부메일
    25: "faml-events", //경조사
    26: "knwld-shrng", //지식공유
    27: "approval", //전자결재
    28: "aplct-stts", //나의신청현황
    29: "erp-appr", //ERP결재
    30: "today-diet", //오늘의 식단
    31: "it-infm", //IT정보
    32: "major-indices", //주요지수
    33: "major-service", //주요서비스
    34: "bulletin-board", //게시판
    35: "webfax", //게시판
    36: "project-content",
    37: "memo", //메모
    40: "my-prj", //프로젝트리스트
    41: "my-member", //구성원 리스트
    43: "frequent-member", //TOP5 협업
    44: "weekly-my-task", //주차별 업무
}

const getFilterText = (filterType, filterValue) => {
    if (filterType === '') filterType = 'end_dt'
    switch (filterType) {
        case 'end_dt_filter':
            if (filterValue === 0) return i18next.t(dictionary.today)
            else if (filterValue === 1) return i18next.t(common.thisWeek)
            else if (filterValue === 2) return i18next.t(common.thisMonth)
            break;
        case 'member_filter':
            if (filterValue === 0) return i18next.t(main.recentCollaborator)
            else if (filterValue === 1) return i18next.t(main.frequentCollaborator)
            else if (filterValue === 2) return i18next.t(dictionary.all)
            break;
        case 'my_prj_filter':
            if (filterValue === 0) return i18next.t(common.recentProject)
            else if (filterValue === 1) return i18next.t(dictionary.starred)
            break;
        case 'month_filter':
            if (filterValue === 0) return i18next.t(common.lastMonth)
            else if (filterValue === 1) return i18next.t(common.lastMonth_plural, {val: 2})
            else if (filterValue === 2) return i18next.t(common.lastMonth_plural, {val: 3})
            break;
        case 'report_filter':
            if (filterValue === 0) return i18next.t(dictionary.all)
            else if (filterValue === 1) return i18next.t(common.my, {val: $t(dictionary.task)})
            break;
        default:
            return i18next.t(dictionary.today)

    }
}
const end_dt_filter = [dictionary.today, common.thisWeek, common.thisMonth];
const member_filter = [main.recentCollaborator, main.frequentCollaborator, dictionary.all];
const my_prj_filter = [common.recentProject, dictionary.starred];
const report_filter = [dictionary.all, common.my]; //임시
const STATUS_GB = ['TOTAL_CNT', 'REQ', 'PROG', 'FEDBK', 'COMP', 'HOLD'];
const STTS = [5, 0, 1, 4, 2, 3];
const STATUS_GB_CLASS = ['request', 'progress', 'completion', 'hold', 'feedback', 'total'];
const STATUS_NM = [dictionary.request, dictionary.progress, dictionary.complete, dictionary.hold, dictionary.feedback, dictionary.tasks];

const allSTTS = "0,1,2,3,4";
const menu_class = [
    'intrn-mail',
    'not-approval',
    'accounting',
    'buy-aplct',
    'public-inspection',
    'receipt',
    'voc',
    'itsm',
];
const menu_nm = [
    '내부메일',
    '미결',
    '재무회계',
    '구매계약',
    '공람',
    '접수',
    'VOC',
    'ITSM',
];

const imageIcon = '<i class="all-setup-icon-type-2"></i> (' + i18next.t('dictionary.image') + ')';
const fileIcon = '<i class="all-setup-icon-type-1"></i> (' + i18next.t('dictionary.file') + ')';

export
{
    pageData,
    taskData,
    end_dt_filter,
    member_filter,
    my_prj_filter,
    report_filter,
    STATUS_GB,
    STTS,
    imageIcon,
    fileIcon,
    STATUS_GB_CLASS,
    STATUS_NM,
    allSTTS,
    WIDGET_SRNO,
    WIDGET,
    getWidgetName,
    getFilterText,
    menu_class,
    menu_nm,
}
